





















































import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import rulesMixin from './rulesMixin'
import { hasValue } from '@/utils/util'

@Component({
	components: {},
})
export default class UsersList extends Mixins(rulesMixin) {
	@Watch('data', { immediate: true })
	private onDataChange() {
		if (!this.data) {
			return
		}

		this.$nextTick(() => {
			const trackRule = this.data.trackRule || {}
			this.subForm.setFieldsValue({
				trackRule: {
					failGenerate: trackRule.failGenerate === '1',
					failTimes: trackRule.failTimes,
				},
			})
		})
	}

	private onFailGenerateChange() {
		this.subForm.setFieldsValue({
			'trackRule.failTimes': '',
		})
	}

	private failTimesValidator(rule: any, value: any, callback: any) {
		const failGenerate = this.subForm.getFieldValue('trackRule.failGenerate')
		if (failGenerate) {
			if (!value) {
				return callback(new Error('连续回访失败天数'))
			}
		}
		callback()
	}

	public getForm() {
		return new Promise((resolve, reject) => {
			this.subForm.validateFields(async (errors: any, values: any) => {
				if (!errors) {
					this.getRuleList()
						.then((list: any) => {
							values.trackRule = values.trackRule || {}
							values.trackRule.failGenerate = values.trackRule.failGenerate
								? '1'
								: '0'

							if (!hasValue(values.trackRule.failTimes)) {
								delete values.trackRule.failTimes
							}
							// values.trackRule.ruleList = list

							values.trackRule.ruleList = list[0]
							resolve(values)
						})
						.catch((err: any) => {
							reject(err)
						})
				} else {
					reject(errors)
				}
			})
		})
	}
}
